import React from "react";

import { Checkbox } from "../../../../components/ui/checkbox";

import FotoProduto from "../FotoProduto";
import { reais } from "../formato";
import LinhaProdutoOferta from "../LinhaProdutoOferta";

// Sabor com algum tamanho na campanha. Tamanho fora vira só um botão pra marcar.
export default function PizzaOferta({ produto, config, padraoPct, onMudarTamanho, onTirar }) {
  const regras = config.pizza?.[produto.id] || {};
  const dentro = produto.tamanhos.filter((t) => regras[t.tamanho]?.participa);
  const fora = produto.tamanhos.filter((t) => !regras[t.tamanho]?.participa);
  return (
    <div className="col-span-full rounded-lg border bg-card px-3 py-2" data-e2e="pizza-oferta">
      <div className="flex items-center gap-3">
        <Checkbox checked onCheckedChange={(v) => !v && onTirar()} aria-label={`Tirar ${produto.name} da campanha`} />
        <FotoProduto url={produto.photo_url} nome={produto.name} />
        <p className="text-sm font-semibold flex-1 min-w-0">{produto.name}</p>
        <span className="text-[11px] text-muted-foreground tabular-nums">{dentro.length} de {produto.tamanhos.length} tamanhos</span>
      </div>
      <div className="divide-y">
        {dentro.map((t) => (
          <LinhaProdutoOferta key={t.tamanho} recuo nome={t.nome} detalhe="tamanho" preco={t.preco} custo={t.custo}
            regra={regras[t.tamanho]} padraoPct={padraoPct} onMudar={(r) => onMudarTamanho(t.tamanho, r)} />
        ))}
      </div>
      {fora.length > 0 && (
        <div className="flex flex-wrap items-center gap-2 py-2 md:pl-8">
          <span className="text-[11px] text-muted-foreground">Fora da campanha:</span>
          {fora.map((t) => (
            <button key={t.tamanho} type="button" onClick={() => onMudarTamanho(t.tamanho, { ...(regras[t.tamanho] || {}), participa: true })}
              className="inline-flex items-center gap-1.5 rounded-full border px-2.5 py-1 text-xs hover:border-primary/50 hover:bg-muted/50">
              <span className="w-3 h-3 rounded-sm border border-primary" /> {t.nome} <span className="text-muted-foreground tabular-nums">{reais(t.preco)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
